import { fetchWithTimeout } from "./httpClient";

/**
 * Builds the abstraction-layer API path that returns explorer metadata:
 * GET `${base}/v1/providers/${provider}/explorer/${address}/link` → `{ "url": "https://..." }`
 */
export function buildProviderExplorerLink(
  baseUrl: string,
  provider: string,
  address: string,
): string {
  const base = baseUrl.replace(/\/$/, "");

  return `${base}/providers/${encodeURIComponent(provider)}/explorer/${encodeURIComponent(address)}/link`;
}

/**
 * Calls the abstraction-layer link endpoint and returns the resolved explorer URL from JSON.
 * Response shape: `{ "url": "https://testnet.snowtrace.io/address/0x..." }`
 */
export async function fetchProviderExplorerDestinationUrl(
  baseUrl: string,
  provider: string,
  address: string,
): Promise<string | null> {
  const endpoint = buildProviderExplorerLink(baseUrl, provider, address);
  const res = await fetchWithTimeout(endpoint, {
    headers: { Accept: "application/json" },
  });
  if (!res.ok) {
    return null;
  }
  let body: unknown;
  try {
    body = await res.json();
  } catch {
    return null;
  }
  if (!body || typeof body !== "object") {
    return null;
  }
  const url = (body as { url?: unknown }).url;
  return typeof url === "string" && url.trim().length > 0 ? url.trim() : null;
}
